import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { configureClient } from '@aiptyg/api-client';
import { buildConfig } from '@aiptyg/config';
import { getAccessToken, handleUnauthorized } from './store/auth.store';
import { App } from './App';
import { handleApiClientEvent, initAdminLogger } from './lib/adminLogger';
import './styles/index.css';

// Initialize API client with app-level callbacks
const config = buildConfig(import.meta.env);

configureClient({
  baseUrl: config.apiBaseUrl,
  securityEnabled: config.requestSecurityEnabled,
  anonymousSecret: config.requestSecurityAnonymousSecret,
  getToken: getAccessToken,
  onUnauthorized: handleUnauthorized,
  onEvent: handleApiClientEvent,
});
initAdminLogger();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
